export default __webpack_public_path__ + "static/media/wftm.6c80f4a2.png";